import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {compose, graphql} from 'react-apollo';
import {FormattedMessage} from 'react-intl';
import messages from './messages';
import {Div} from 'components/primitives/body';
import {DisplaySmallest} from 'components/primitives/display';
import {FormField} from 'components/inputs/FormField';
import {Button} from 'components/buttons/Button';
import {withManageToasts} from 'containers/Toasts/withManageToasts';
import {createNewToastId} from 'containers/Toasts/actions';
import {SEND_SIGNUP_EMAIL} from './queries';


class ExpiredTokenContainer extends React.Component {
    static propTypes = {
        userId: PropTypes.string,
        email: PropTypes.string,
        sendSignupEmail: PropTypes.func.isRequired,
        displayToast: PropTypes.func
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            emailSent: false,
            emailSentError: ''
        };
    }

    sendSignupEmail = () => {

        this.setState({loading: true});
        const userId = this.props.userId;
        const toastId = createNewToastId();
        this.props.displayToast(toastId, {
            loading: true,
            children: <Div/>
        });

        this.props.sendSignupEmail(userId).then(resp => {
            const {ok, errorMessage} = resp.data.sendSignupEmail;

            if (ok) {
                this.setState({loading: false, emailSent: true});
                this.props.displayToast(toastId, {
                    success: true,
                    children: <Div><FormattedMessage {...messages.sendEmailSuccess}/></Div>,
                    closeAfter: 3000
                });
            }
            else {
                throw errorMessage;
            }
        }).catch(error => {
            console.log(error);
            this.setState({loading: false, emailSentError: error});
            this.props.displayToast(toastId, {
                error: true,
                children: <Div><FormattedMessage {...messages.sendEmailError}/></Div>,
                closeAfter: 3000
            });
        });
    };

    render() {
        return (
            <Div>
                <DisplaySmallest>
                    <FormattedMessage {...messages.title}/>
                </DisplaySmallest>

                <TextWrapper>
                    <p><FormattedMessage {...messages.description}/></p>
                </TextWrapper>

                {this.state.emailSent ? (
                    <Div style={{color: '#1ca01c', margin: '20px 0'}}>
                        <p>
                            <FormattedMessage {...messages.emailSent} values={{email: <b>{this.props.email}</b>}}/>
                        </p>
                    </Div>
                ) : (
                    <FormField>
                        <Button loading={this.state.loading} onClick={this.sendSignupEmail}>
                            <FormattedMessage {...messages.resendEmail}/>
                        </Button>
                    </FormField>
                )}
            </Div>
        );
    }
}

const TextWrapper = styled.div`
  margin: 20px 0;
`;


export default compose(
    graphql(SEND_SIGNUP_EMAIL, {
        props: ({ mutate }) => ({
            sendSignupEmail: (userId) => {
                const data = {userId};

                return (
                    mutate({
                        variables: {data}
                    })
                );
            }
        })
    }),
)(withManageToasts(ExpiredTokenContainer));
